module.exports = __webpack_public_path__ + "static/media/sfuidisplay-regular-webfont.c6d22db4.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sfuidisplay-regular-webfont.woff2
// module id = 255
// module chunks = 0